<template>
  <div class="basebandPipeline">
    <h2>Baseband Pipeline: FRB Cluster</h2>
    <b-card-group deck>
      <b-card
        title= "Num events to process"
        tag="article"
        style="background-color: black; color: white"
        class="mb-1"
      >
        <b-card-text>
          <p style="font-size: 500%; color: orange">{{eventsInQueue.length}}</p>
        </b-card-text>
      </b-card>
      <b-card
        title= "Processing Event"
        tag="article"
        style="background-color: black; color: white"
        class="mb-1"
      >
        <b-card-text>
          <p style="font-size: 200%; text-align: left; color: orange">Event Id ={{eventInProgress}} <br/>Running for = {{parseFloat(eventInProgressDuration/3600).toFixed(3)}} hrs <span style="font-size: 50%">(should take less than 4 hrs)</span></p>
        </b-card-text>
      </b-card>
    </b-card-group>

    <details style="text-center">
      <summary>Show Pipeline Status</summary>
      <b-table show-empty
       small
       dark
       sticky-header="400px"
       responsive
       :items="jobStatus"
      >
        <template #cell(status)="row">
          <b-icon v-if="row.item.status==='Finished'" icon="check-square-fill" aria-hidden="true" font-scale="1.5" variant="success"></b-icon>
          <b-icon v-else-if="row.item.status==='In Progress'" icon="arrow-clockwise" aria-hidden="true" font-scale="1.5" variant="primary" animation="spin-pulse"></b-icon>
          <b-icon v-else icon="three-dots" variant="warning" font-scale="1.5"></b-icon>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="showLogs(row.item, row.index, $event.target)" class="mr-1">
            Show Logs
          </b-button>
        </template>
      </b-table>
    </details>
    <details style="text-center">
      <summary>Show Pipeline Logs</summary>
      <b-row>
        <b-col md="12">
          <b-card
            tag="article"
            class="mb-2"
            border-variant="dark"
            :header="pipelineLog"
            header-bg-variant="dark"
            header-text-variant="light"
          >
            <b-card-text>
              <div style="text-align: left" id="basebandLogs">
                Select Logs to view.
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </details>
  </div>
</template>

<script>
import { AdminMixin } from '../mixins/adminMixin.js'
export default{
  mixins: [AdminMixin],
  data () {
    return {
      jobStatus: [],
      pipelineLog: '',
      eventsInQueue: [],
      eventInProgress: '--',
      baseUrl: 'https://frb.chimenet.ca/frb-master/'
    }
  },
  mounted () {
    this.userName = localStorage.username
    this.refreshToken()
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(this.baseUrl + '/v1/admin/role/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.getUserRole(response.body)
        this.$http.get(this.baseUrl + '/v1/admin/team/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            this.userTeam = response.body
          })
      })
    this.getUsers()
    this.getAnalysisEvents()
    this.fetchJobStatus()
    setInterval(this.fetchJobStatus, 5000)
    this.fetchEventQueue()
    setInterval(this.fetchEventQueue, 5000)
  },
  methods: {
    fetchEventQueue () {
      const bucks = ['baseband-pipeline']
      let url = 'https://frb.chimenet.ca/maestro/buckets/status'
      this.$http.post(url, bucks, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.eventInProgress = '--'
          this.eventInProgressDuration = 0
          let payload = response.body[0]
          let priorities = Object.keys(payload['distributors_state'])
          let events = []
          for (let j = 0; j < priorities.length; j++) {
            let workItems = payload['distributors_state'][priorities[j]]['items']
            for (let i = 0; i < workItems.length; i++) {
              let work = JSON.parse(workItems[i])
              events.push(work.event_number)
            }
            let workStatus = payload['distributors_state'][priorities[j]]['status']
            let keys = Object.keys(workStatus)
            for (let i = 0; i < keys.length; i++) {
              let work = JSON.parse(keys[i])
              if (Object.keys(workStatus[keys[i]]).includes('withdrawn_at') === true) {
                let start = workStatus[keys[i]]['withdrawn_at']
                if (Object.keys(workStatus[keys[i]]).includes('concluded_at') === false) {
                  let stop = Math.floor(Date.now() / 1000)
                  this.eventInProgress = work['event_number']
                  this.eventInProgressDuration = stop - start
                  break
                }
              }
            }
          }
          this.eventsInQueue = events
        })
    },
    fetchJobStatus () {
      const bucks = ['baseband-initialize', 'baseband-beamform', 'baseband-merge', 'baseband-analysis', 'baseband-finalize', 'baseband-polarization']
      let url = 'https://frb.chimenet.ca/maestro/buckets/status'
      this.$http.post(url, bucks, {responseType: 'json', timeout: 10000})
        .then(response => {
          let buckets = response.body
          let statuses = []
          for (let x = 0; x < buckets.length; x++) {
            let payload = buckets[x]
            let priorities = Object.keys(payload['distributors_state'])
            for (let j = 0; j < priorities.length; j++) {
              let workStatus = payload['distributors_state'][priorities[j]]['status']
              let keys = Object.keys(workStatus)
              for (let i = 0; i < keys.length; i++) {
                let status = {}
                let work = JSON.parse(keys[i])
                status['event_number'] = work['event_number']
                status['pipeline'] = payload['name'].split('-')[1]
                status['stage'] = work['baseband_pipeline']
                status['job_id'] = work['job_id']
                if (status['job_id'] === undefined) {
                  status['job_id'] = '--'
                }
                delete work['pipeline_user']
                status['status'] = 'Queued'
                let start = Math.floor(Date.now() / 1000)
                let stop = Math.floor(Date.now() / 1000)
                if (Object.keys(workStatus[keys[i]]).includes('withdrawn_at') === true) {
                  status['status'] = 'In Progress'
                  start = workStatus[keys[i]]['withdrawn_at']
                }
                if (Object.keys(workStatus[keys[i]]).includes('concluded_at') === true) {
                  status['status'] = 'Finished'
                  stop = workStatus[keys[i]]['concluded_at']
                }
                status['duration (s)'] = stop - start
                // status['work'] = work
                status['actions'] = ''
                statuses.push(status)
              }
            }
          }
          this.jobStatus = statuses
        })
    },
    showLogs (item, index, button) {
      const event = item.event_number
      let url = 'https://frb.chimenet.ca/frb-master/v1/events/' + event
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          let ymd = response.body['measured_parameters'][0]['datetime'].split(' ')[0]
          ymd = ymd.split('-')
          const jobId = item.job_id
          let pipeline = item.pipeline
          let stage = item.stage
          this.pipelineLog = pipeline + ' Logs'
          if (jobId !== '--') {
            this.pipelineLog = this.pipelineLog + ': Job ID = ' + jobId
          }
          if (pipeline === 'analysis') {
            if (stage === 'refinement') {
              pipeline = 'brightest'
            } else if (stage === 'localization') {
              pipeline = 'localization'
            } else {
              pipeline = 'waterfall'
            }
          } else if (pipeline === 'merge') {
            pipeline = 'merge'
          } else if (pipeline === 'initialize') {
            pipeline = 'initialize'
          } else if (pipeline === 'finalize') {
            pipeline = 'finalize'
          } else if (pipeline === 'beamform') {
            pipeline = 'tiedbeam_' + stage + '_' + jobId
          }
          var filePath = '/data/chime/baseband/processed/' + ymd[0] + '/' + ymd[1] + '/' + ymd[2] + '/astro_' + event + '/logs/baseband-' + event + '-' + pipeline + '.log'
          this.$http.get('https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=' + filePath)
            .then(response => {
              let customItems = response.body
              customItems = customItems.split('[20')
              for (let i = 0; i < customItems.length; i++) {
                if (i > 0) {
                  customItems[i] = '<br/>[20' + customItems[i]
                } else {
                  customItems[i] = customItems[i]
                }
              }
              customItems = customItems.join('')
              document.getElementById('basebandLogs').innerHTML = customItems
            })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analysis/baseband_pipeline.vue